module.exports = __webpack_public_path__ + "static/media/plantF.92149d54.png";